class BuscadorEHelp extends Widget {
    constructor() {
        super("#qelp-search");
        this.input = this.element.querySelector("input[id='search']");
        this.form = this.element.querySelector("form");
        this.suggestions = this.element.querySelector(".qclatam-suggestions-list");
        this.top_list_item_search = document.querySelector(".mdn-Menu-top-list-item-search")
        this.completions;
        this.loading = false;
        this.form.addEventListener("submit", e=> {
            e.preventDefault();
            this.submitSearch();
        })
        this.input.addEventListener("keyup", e=> {
            e.preventDefault();
            switch (e.key) {
                case "ArrowUp":
                    this.nextSuggetionItem("ArrowUp");
                    break;
                case "ArrowDown":
                    this.nextSuggetionItem("ArrowDown");
                    break;
                case "Escape":
                    this.suggestions.classList.remove("active");
                    document.body.classList.remove("mdn-Menu-top-is-active");
                    this.top_list_item_search.classList.remove("mdn-is-active");
                    this.input.blur();
                    this.input.value = "";
                    break;
                case "Enter":
                    const suggestion = this.suggestions.querySelector("li.active");
                    if (this.suggestions.classList.contains("active") && suggestion) {
                        this.updateInputField(e);
                    }
                    this.submitSearch();
                    break;
                default:
                    this.checkCompletions(e);
                    break;
            }
        })
    }
    submitSearch() {
        terms = encodeURI(this.input.value);
        if (terms.length==0) return;
        url = eHelpFramework.getRoot(eHelpFramework.getRoute("search_results")) +`/${terms}`;
        window.location.href = url;                    
    }
    nextSuggetionItem(direction) {
        var current = this.suggestions.querySelector("li.active");
        var next;
        if (!current) {
            next = this.suggestions.querySelector("li:first-child");
            next.classList.add("active");
        } else {
            current.classList.remove("active");
            next = direction=="ArrowDown" ? current.nextElementSibling : current.previousElementSibling
            next.classList.add("active");
        }
    }
    updateInputField(e) {
        var suggestion;
        console.log(e)

        if (e.type=="click") {
            suggestion = e.currentTarget;
        } else {
            suggestion = this.suggestions.querySelector("li.active");
        }
        
        this.input.value = suggestion.dataset.term
        this.suggestions.classList.remove("active");
    }
    async checkCompletions(e) {

        clearTimeout(this.debounceTimer);
        
        // Set a new debounce timer (adjust delay as needed)
        this.debounceTimer = setTimeout(async () => {
            const query = this.input.value.trim();
            if (!query) {
                this.suggestions.classList.remove("active");
                return;
            }
            if (this.loading) return;
            
            this.loading = true;
            const currentQuery = query;
            
            // Fetch autocomplete data
            const response = await this.parent.postData("autocomplete", { term: query });
            
            // If the user changed the input while waiting, abort processing.
            if (this.input.value.trim() !== currentQuery) {
                this.loading = false;
                return;
            }
            
            // Process the returned suggestions
            this.completions = response.results.map(term => ({ term }));
            this.loading = false;
            
            console.log(this.completions);
            
            // Setup Fuse.js with options for fuzzy searching.
            const fuseOptions = {
                includeScore: true,
                keys: ['term'],
                threshold: 0.7,
                distance: 20
            };
            const fuse = new Fuse(this.completions, fuseOptions);
            const searchResults = fuse.search(query);
            
            // Build the suggestions list (limit to 10 items).
            const suggestionsList = document.createElement("ul");
            const maxSuggestions = 10;
            let count = 0;
            for (const result of searchResults) {
                if (count >= maxSuggestions) break;
                const li = document.createElement("li");
                li.classList.add("mdn-Text", "mdn-Text--bod", "mdn-Text--md");
                li.dataset.term = result.item.term;
                li.innerHTML = '<em class="mdn-Icon-lupa mdn-Icon--md"></em>' + result.item.term;
                li.addEventListener("click", e => {
                    this.updateInputField(e);
                    this.submitSearch();
                });
                suggestionsList.append(li);
                count++;
            }
            
            // Display or hide the suggestions based on the results.
            if (count > 0) {
                this.suggestions.innerHTML = "";
                this.suggestions.append(suggestionsList);
                this.suggestions.classList.add("active");
            } else {
                this.suggestions.classList.remove("active");
            }
        }, 300); // debounce delay in milliseconds
    }
}
window.addEventListener("eHelpFrameworkReady", e => {
    eHelpFramework.widgets.push(new BuscadorEHelp());
});
